module.exports = __webpack_public_path__ + "static/media/icon_schedule_film_gray.c41b8a08.svg";